// Country catalog keyed by ISO 3166-1 alpha-2 code.
// Ported from country_catalog.dart

export type Country = Readonly<{
  countryCode: string;
  name: string;
  phoneCode: string;
  flag: string;
}>;

const c = (countryCode: string, name: string, phoneCode: string, flag: string): Country =>
  Object.freeze({ countryCode, name, phoneCode, flag });

export const countryCatalogByIsoCode: Readonly<Record<string, Country>> = Object.freeze({
  IN: c('IN', 'India', '+91', '🇮🇳'),
  US: c('US', 'United States', '+1', '🇺🇸'),
  CA: c('CA', 'Canada', '+1', '🇨🇦'),
  GB: c('GB', 'United Kingdom', '+44', '🇬🇧'),
  AU: c('AU', 'Australia', '+61', '🇦🇺'),
  JP: c('JP', 'Japan', '+81', '🇯🇵'),
  DE: c('DE', 'Germany', '+49', '🇩🇪'),
  FR: c('FR', 'France', '+33', '🇫🇷'),
  BE: c('BE', 'Belgium', '+32', '🇧🇪'),
  NL: c('NL', 'Netherlands', '+31', '🇳🇱'),
  IT: c('IT', 'Italy', '+39', '🇮🇹'),
  CH: c('CH', 'Switzerland', '+41', '🇨🇭'),
  AT: c('AT', 'Austria', '+43', '🇦🇹'),
  ES: c('ES', 'Spain', '+34', '🇪🇸'),
  RU: c('RU', 'Russia', '+7', '🇷🇺'),
  DK: c('DK', 'Denmark', '+45', '🇩🇰'),
  SE: c('SE', 'Sweden', '+46', '🇸🇪'),
  NO: c('NO', 'Norway', '+47', '🇳🇴'),
  PL: c('PL', 'Poland', '+48', '🇵🇱'),
  FI: c('FI', 'Finland', '+358', '🇫🇮'),
  PT: c('PT', 'Portugal', '+351', '🇵🇹'),
  IE: c('IE', 'Ireland', '+353', '🇮🇪'),
  PE: c('PE', 'Peru', '+51', '🇵🇪'),
  MX: c('MX', 'Mexico', '+52', '🇲🇽'),
  CU: c('CU', 'Cuba', '+53', '🇨🇺'),
  AR: c('AR', 'Argentina', '+54', '🇦🇷'),
  BR: c('BR', 'Brazil', '+55', '🇧🇷'),
  CL: c('CL', 'Chile', '+56', '🇨🇱'),
  CO: c('CO', 'Colombia', '+57', '🇨🇴'),
  VE: c('VE', 'Venezuela', '+58', '🇻🇪'),
  MY: c('MY', 'Malaysia', '+60', '🇲🇾'),
  ID: c('ID', 'Indonesia', '+62', '🇮🇩'),
  PH: c('PH', 'Philippines', '+63', '🇵🇭'),
  NZ: c('NZ', 'New Zealand', '+64', '🇳🇿'),
  SG: c('SG', 'Singapore', '+65', '🇸🇬'),
  TH: c('TH', 'Thailand', '+66', '🇹🇭'),
  KR: c('KR', 'South Korea', '+82', '🇰🇷'),
  VN: c('VN', 'Vietnam', '+84', '🇻🇳'),
  CN: c('CN', 'China', '+86', '🇨🇳'),
  TR: c('TR', 'Turkey', '+90', '🇹🇷'),
  PK: c('PK', 'Pakistan', '+92', '🇵🇰'),
  AF: c('AF', 'Afghanistan', '+93', '🇦🇫'),
  LK: c('LK', 'Sri Lanka', '+94', '🇱🇰'),
  MM: c('MM', 'Myanmar', '+95', '🇲🇲'),
  IR: c('IR', 'Iran', '+98', '🇮🇷'),
  EG: c('EG', 'Egypt', '+20', '🇪🇬'),
  ZA: c('ZA', 'South Africa', '+27', '🇿🇦'),
  MU: c('MU', 'Mauritius', '+230', '🇲🇺'),
  NG: c('NG', 'Nigeria', '+234', '🇳🇬'),
  ET: c('ET', 'Ethiopia', '+251', '🇪🇹'),
  KE: c('KE', 'Kenya', '+254', '🇰🇪'),
  NI: c('NI', 'Nicaragua', '+505', '🇳🇮'),
  PG: c('PG', 'Papua New Guinea', '+675', '🇵🇬'),
  TO: c('TO', 'Tonga', '+676', '🇹🇴'),
  SB: c('SB', 'Solomon Islands', '+677', '🇸🇧'),
  VU: c('VU', 'Vanuatu', '+678', '🇻🇺'),
  FJ: c('FJ', 'Fiji', '+679', '🇫🇯'),
  CK: c('CK', 'Cook Islands', '+682', '🇨🇰'),
  WS: c('WS', 'Samoa', '+685', '🇼🇸'),
  KI: c('KI', 'Kiribati', '+686', '🇰🇮'),
  NC: c('NC', 'New Caledonia', '+687', '🇳🇨'),
  KP: c('KP', 'North Korea', '+850', '🇰🇵'),
  HK: c('HK', 'Hong Kong', '+852', '🇭🇰'),
  KH: c('KH', 'Cambodia', '+855', '🇰🇭'),
  TW: c('TW', 'Taiwan', '+886', '🇹🇼'),
  MV: c('MV', 'Maldives', '+960', '🇲🇻'),
  BD: c('BD', 'Bangladesh', '+880', '🇧🇩'),
  MN: c('MN', 'Mongolia', '+976', '🇲🇳'),
  NP: c('NP', 'Nepal', '+977', '🇳🇵'),
  BT: c('BT', 'Bhutan', '+975', '🇧🇹'),
  IQ: c('IQ', 'Iraq', '+964', '🇮🇶'),
  JO: c('JO', 'Jordan', '+962', '🇯🇴'),
  KW: c('KW', 'Kuwait', '+965', '🇰🇼'),
  LB: c('LB', 'Lebanon', '+961', '🇱🇧'),
  OM: c('OM', 'Oman', '+968', '🇴🇲'),
  PS: c('PS', 'Palestine', '+970', '🇵🇸'),
  QA: c('QA', 'Qatar', '+974', '🇶🇦'),
  SA: c('SA', 'Saudi Arabia', '+966', '🇸🇦'),
  YE: c('YE', 'Yemen', '+967', '🇾🇪'),
  AE: c('AE', 'United Arab Emirates', '+971', '🇦🇪'),
  BH: c('BH', 'Bahrain', '+973', '🇧🇭'),
  IL: c('IL', 'Israel', '+972', '🇮🇱'),
});

export const globalCountriesInfo: readonly Country[] = Object.freeze(
  Object.values(countryCatalogByIsoCode)
);

// First country listed wins for shared codes (e.g. +1 → United States).
export const phoneCodeToCountryName: Readonly<Record<string, string>> = Object.freeze(
  globalCountriesInfo.reduce<Record<string, string>>((acc, { phoneCode, name }) => {
    if (!(phoneCode in acc)) acc[phoneCode] = name;
    return acc;
  }, {})
);

export const countryCodeToPhoneCode: Readonly<Record<string, string>> = Object.freeze(
  Object.fromEntries(globalCountriesInfo.map((x) => [x.countryCode, x.phoneCode]))
);

export const phoneCodeFromCountryName: Readonly<Record<string, string>> = Object.freeze(
  Object.fromEntries(globalCountriesInfo.map((x) => [x.name, x.phoneCode]))
);

export const countryNameToCountryCode: Readonly<Record<string, string>> = Object.freeze(
  Object.fromEntries(globalCountriesInfo.map((x) => [x.name, x.countryCode]))
);
